
// vuex的user模块入口
import { setData, getData} from "@/utils/auth";

// 状态 类似于.vue里面的data配置项，是放数据的
const state = {
    //这样写，别的地方就能从vuex里面读，而非localStorage
    //这样可以大大减少读取本地存储的次数，提高性能
    // 所以你这样写，只在项目启动时，以及刷新时，从本地存储读一回
    // 👇的代码必须使用？，因为写下getData().tokenId的代码时，data已经保存在本地了
    token: getData()?.tokenId || '',
    userData: getData() || ''

};
  
// 变异 类似于.vue里面的methods配置项， 是放具体方法的  
  const mutations = {
    SET_DATA(state, data) {
      state.token = data.tokenId;
      state.userData = data;
      // setToken(data.tokenId); //保存到localStorage
      setData(data);
    }
  };
  
  //动作 通知mutations，你该变异啦。在mutations变异之前对数据进行一些处理操作
  const actions = {
    // setData里面第一个参数其实一个mini版的store，里面有store身上重要的东西
    // {commit}的意思，就是把commit从第一个参数（store）身上解构下来，
    // 这是解构赋值的一种
    setData({ commit }, data) {
        // SET_DATA是通知mutations进行变异，这个，你如果给起名叫setData也没问题。
        // 但是为了区分，别和actions里面的setData混了
      commit('SET_DATA', data);
    }
  };
  
  export default {
    // 命名空间
    namespaced: true,
    // 把state mutations actions交出去，这里既然导出了，待会别的地方就一定有引入的
    state,
    mutations,
    actions
  };
  